import { render, staticRenderFns } from "./SnapshotItem.vue?vue&type=template&id=2587b1ee&"
import script from "./SnapshotItem.vue?vue&type=script&lang=js&"
export * from "./SnapshotItem.vue?vue&type=script&lang=js&"
import style0 from "./SnapshotItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports